<template>
	<svg xmlns="http://www.w3.org/2000/svg" height="180" width="180" id="Layer_1" data-name="Layer 1" viewBox="0 0 301.87 277.59">
		<defs></defs>
		<title>Tiger-dark</title>
		<polygon
			class="cls-1"
			points="84.18 106.44 40.67 206.31 39.67 208.62 265.52 208.62 265.52 208.62 265.72 205.34 236.85 111.7 235.39 106.62 167.75 106.62 84.18 106.44"
		/>
		<path class="cls-2" d="M57.91,89.93,93.47,39,86,76.49l-39.56,72.9s1.11-8,4.14-24.73S57.91,89.93,57.91,89.93Z" transform="translate(-4.26 -4.58)" />
		<path
			class="cls-3"
			d="M9.65,55.41c-1.59,0-1.39,1-1.39,1.91,0,0-3.94,222-4,223.53s1,1.31,1,1.31l34.92-.33.25-119.11,19-79.1L62,83.31V55.39Zm48.63,26.3c-.89.08-.84.81-.92,1.46S39,163,39,163V280.2H6.32l4.11-222h49.4L60.16,82a4.65,4.65,0,0,0-1.88-.31Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-3" points="6.64 50.88 62.33 1.15 96.21 0.32 62.01 0 4.34 51.08 6.64 50.88" />
		<path
			class="cls-3"
			d="M61.15,55.66S74.84,37.1,83.68,25.31,100.46,4.9,100.46,4.9,92,16,84.2,26.61,61.89,56.94,61.89,56.94Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-3" points="57.75 78.73 96.86 19.31 96.24 0.32 95.41 19.33 57.75 75.98 57.75 78.73" />
		<polygon class="cls-2" points="40.73 151.35 42.35 143.54 81.72 71.91 80.28 78.73 40.73 151.35" />
		<polygon class="cls-3" points="40.73 206.22 83.69 107.71 82.84 71.91 81.72 108.58 40.73 206.22" />
		<path
			class="cls-3"
			d="M40.21,281.83s66.34-1.27,114.56-1.27,114.21.56,114.21.56l.78.71s-96.89-.08-115.21,0S40.21,281.83,40.21,281.83Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-3" points="35.75 216.62 158.49 216.62 265.52 216.62 265.5 218.62 158.49 218.62 35.75 218.12 35.75 216.62" />
		<polygon class="cls-3" points="38.75 208.94 38.75 212.62 137.91 212.62 266.98 213.34 265.59 208.45 38.75 208.94" />
		<path class="cls-3" d="M42,213.9v4.22l228,.47v-1.5H43V214l226.76-.83H42.52C42.12,213.2,42,213.62,42,213.9Z" transform="translate(-4.26 -4.58)" />
		<path
			class="cls-3"
			d="M302.85,59.71c-2.82,0-46-1.59-47.78-1.59s-2.63.94-2.63,1.88S251,79.52,251,81c0,0-.1,3.19,1,3.76s2.81.09,3.1,2.16,15.48,76.59,15.48,76.59S269,278.91,268.87,280s.27,1.82.89,1.82h31.68c1.88,0,2.07-.38,2.07-1.3S306.13,67.38,306.13,64,305.66,59.71,302.85,59.71ZM301.3,278c0,.74.08,1.74-1.25,1.74H272.28c-.86,0-1.09-.6-1.08-1.26,0,0,1.5-111.41,1.5-113a32.7,32.7,0,0,0-1.08-6.66C271,156,257.4,86.78,257,85.12s-1.5-1.58-2.25-1.83a1.83,1.83,0,0,1-1.49-1.91c0-1.25,1.49-20.87,1.49-20.87s47.27,1.69,48,1.69a1.11,1.11,0,0,1,1.16,1C303.88,63.7,301.3,277.29,301.3,278Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-3" points="247.16 79.34 225.38 22.56 226.94 3.32 226.16 22.45 246.92 73.85 247.16 79.34" />
		<polygon class="cls-3" points="248.39 54.4 226.38 1.54 261.4 2.54 227.38 2.32 250.08 53.54 248.39 54.4" />
		<polygon class="cls-3" points="299.62 55.19 261.4 2.54 301.23 55.96 299.62 55.19" />
		<polygon class="cls-3" points="237.73 56.09 238.72 110.75 265.72 205.23 236.85 111.68 237.73 56.09" />
		<polygon class="cls-2" points="261.4 142.62 251.29 85.01 247.16 83.3 231.97 41.33 260.78 146.82 261.4 142.62" />
		<polygon class="cls-3" points="88.07 111.84 50.37 200.99 87.52 110.62 232.11 111.89 130.1 111.62 88.07 111.84" />
		<path
			class="cls-3"
			d="M172,115.38l63.15.17a1,1,0,0,1,1.19.77.77.77,0,0,1,0,.15c.2.73,23.47,89.4,23.47,89.4l-24.46-89.32-143-.13Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-2" points="49.85 202.04 92.1 202.19 80.88 128.84 49.85 202.04" />
		<polygon class="cls-2" points="222.3 200.62 255.23 200.62 237.37 135.89 222.3 200.62" />
		<path
			class="cls-3"
			d="M54.65,205.87s71.38-1.45,102.29-1.27,102.83,1.27,102.83,1.27-67.41,2-102.56,1.8S54.65,205.87,54.65,205.87Z"
			transform="translate(-4.26 -4.58)"
		/>
		<polygon class="cls-3" points="90.14 107.54 129 107.33 128.92 106.66 90.14 107.54" />
		<polygon class="cls-3" points="128.92 106.58 229.73 107.62 129 107.33 128.92 106.58" />
		<polygon class="cls-3" points="48.97 106.48 42.92 143.16 81.44 72.43 89.22 35.92 55.36 84.31 90.27 33.64 82.18 72.65 42.43 144.81 48.97 106.48" />
		<polygon class="cls-3" points="239.98 65.09 260.7 139.01 253.44 95.14 262 143.52 261.4 144.44 239.98 65.09" />
	</svg>
</template>

<script>
	export default {
		name: 'TigerScannerSVG'
	};
</script>

<style scoped>
	.cls-1 {
		fill: #d9dce1;
	}
	.cls-2 {
		fill: #d3d3d3;
	}
	.cls-3 {
		fill: #707070;
	}
</style>
